export default {
  TITLE: 'The Link Has Expired',
  DESCRIPTION: 'URLの有効期限が切れています。',
};
